import React from 'react';
import '../template-file-css/document-file-template.css';


export const TCC_BriefIntakeForm = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='TCC_BriefIntakeForm' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h4>Texas Care Center New Client Referral Form</h4></center></p>

                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Referring Organization Name and Contact Info.</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Date</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtOrganizationName' name='txtOrganizationName' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDate' name='txtDate' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Client's Full Name </span> </td>
                        <td className='w-250'> <span className='eleHeader'>D.O. B</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtClientFullName' name='txtClientFullName' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDob' name='txtDob' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <span className='eleHeader'>Parent/Guardian Name </span> </td>
                        <td className='w-200'> <span className='eleHeader'>Relationship</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Phone Number</span> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <input type='text' id='txtGuardianName' name='txtGuardianName' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtRelationship' name='txtRelationship' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPhoneNumber' name='txtPhoneNumber' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Email-Address</span>
                <input type='text' id='txtEmailAddress' name='txtEmailAddress' className='add-only' /> 
                </p>

                <table>
                <tr>
                        <td className='w-450'> <span className='eleHeader'>Client's Address</span> </td>
                        <td className='w-100'> <span className='eleHeader'>City</span> </td>
                        <td className='w-100'> <span className='eleHeader'>State</span> </td>
                        <td className='w-100'> <span className='eleHeader'>Zip Code</span> </td>
                    </tr>
                <tr>
                        <td className='w-450'> <input type='text' id='txtClientAddress' name='txtClientAddress' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtCity' name='txtCity' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtState' name='txtState' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtZipCode' name='txtZipCode' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Client's Insurance Provider (if known)</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Policy Number</span> </td>
                    </tr>
                <tr>
                        <td className='w-500'> <input type='text' id='txtInsuranceProvider' name='txtInsuranceProvider' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPolicyNumber' name='txtPolicyNumber' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Services Requested (Counseling/MHR)</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Diagnosis/Reason for Referral</span> </td>
                    </tr>
                <tr>
                        <td className='w-375'> <input type='text' id='txtServicesRequested' name='txtServicesRequested' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtDiagnosis' name='txtDiagnosis' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Is this request urgent or standard? If urgent, please explain why:</span>
                    <textarea id='txtRequestUrgent' name='txtRequestUrgent' className='add-only'></textarea>
                </p>

                <p className='w-750'><b>For Texas Care Office Use:</b></p>

                <table>
                <tr>
                        <td className='w-500'> <span className='eleHeader'>Assessor Name</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Assessment Date:</span> </td>
                    </tr>
                <tr>
                        <td className='w-500'> <input type='text' id='txtAssessorName' name='txtAssessorName' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtAssessmentDate' name='txtAssessmentDate' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Appointment Status (Kept/Rescheduled/Cancelled)</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Reschedule Date (if applicable)</span> </td>
                    </tr>
                <tr>
                        <td className='w-500'> <input type='text' id='txtAppointmentStatus' name='txtAppointmentStatus' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtRescheduleDate' name='txtRescheduleDate' className='add-only' /> </td>
                    </tr>
                </table>


            </div>
        </form>
    )
}

